import { IReferral } from '@sales-center/common'
import { useCallback } from 'react'
import { Props } from '../UpdateReferral'
import { useUpdateReferralDrawer } from '../UpdateReferralDrawer/useUpdateReferralDrawer'
import { useFormikContext } from 'formik'
import { ILeadFormModel } from '@user/components/Leads/AddLeadPage/typings'
import { initReferralDataModel } from '@user/components/Referrals/components/UpdateReferral/UpdateReferralDrawer/hooks/utils'
import { ReferralFormVariant } from '@user/components/Referrals/components/UpdateReferral/TidalUpdateReferral'

type UseHandlersProps = Pick<Props, 'onChange'> & {
  formVariant: ReferralFormVariant
}

export function useHandlers(props: UseHandlersProps) {
  const { onChange, formVariant } = props
  const context = useFormikContext<ILeadFormModel>()

  const {
    onCloseUpdateReferralDrawer,
    onOpenUpdateReferralDrawer,
    updateReferralDrawerOpen,
  } = useUpdateReferralDrawer()

  const onButtonClick = useCallback(() => {
    onOpenUpdateReferralDrawer()
    if (formVariant === ReferralFormVariant.Inline) {
      context?.setFieldValue?.('referral', initReferralDataModel())
    }
  }, [context, formVariant, onOpenUpdateReferralDrawer])

  const handleSave = useCallback(
    (referral: IReferral) => {
      onChange(referral)
      onCloseUpdateReferralDrawer()
    },
    [onChange, onCloseUpdateReferralDrawer],
  )

  const onCloseReferralDrawer = useCallback(() => {
    if (formVariant === ReferralFormVariant.Inline) {
      context?.setFieldValue?.('referral', undefined)
    }
    onCloseUpdateReferralDrawer()
  }, [formVariant, onCloseUpdateReferralDrawer, context])

  return {
    onButtonClick,
    handleSave,
    updateReferralDrawerOpen,
    onCloseReferralDrawer,
  } as const
}
